import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createUserRoles, fetchUsers, updateUserRoles } from './Users.services.ts';
import { toast } from 'react-toastify';
import i18n from '../../utils/i18n.ts';
import type { ApiError } from '../../types/App.ts';
import { useMsal } from '@azure/msal-react';

export const useService = () => {
  const { accounts } = useMsal();
  const queryClient = useQueryClient();

  const hasAccount = accounts.length > 0;

  const crateMutation = useMutation({
    mutationFn: createUserRoles,
    onSuccess: () => {
      toast.success(i18n.t('success.api.put-item', { item: i18n.t('module.user') }));
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message || error.message);
    },
  });

  const updateMutation = useMutation({
    mutationFn: updateUserRoles,
    onSuccess: () => {
      toast.success(i18n.t('success.api.put-item', { item: i18n.t('module.user') }));
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message || error.message);
    },
  });

  const { data: users } = useQuery({
    queryKey: ['users'],
    queryFn: fetchUsers,
    enabled: hasAccount,
    retry: false,
  });
  return { crateMutation, updateMutation, users };
};